import type {
  Area,
} from 'react-easy-crop';

const crop = async (image: string, area: Area): Promise<string> => {
  return new Promise((resolve) => {
    if (
      !image
    ) return resolve(null);

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const imageObj = new Image();

    const {
      x,
      y,
      width,
      height,
    } = area;

    canvas.width = width;
    canvas.height = height;

    imageObj.onload = () => {
      context.drawImage(
        imageObj,
        x,
        y,
        width,
        height,
        0,
        0,
        width,
        height,
      );
      resolve(canvas.toDataURL());
    };

    imageObj.src = image;
  });
};

export default crop;
